export default __webpack_public_path__ + "static/media/InsideStomach_01.83ed6414.png";